import React from 'react';

import Layout from '../../components/Layout';
import PartialsHeader from '../../components/Partials/PartialsHeader';
import PartialsQuestion from '../../components/Partials/PartialsQuestion';
import MainView from '../../components/service/Products/MainView';

const BuildingProducts = () => {
  return (
    <Layout
      title="Build your digital product with Ulam Labs"
      description="Delivering a new IT product or system that serves unique processes requires custom development. We help to build systems designed for your individual business requirements and needs."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Building products</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <MainView />
      <PartialsQuestion />
    </Layout>
  );
};

export default BuildingProducts;
